import './css/Mensajes.css';
import { useEffect, useRef, useState } from "react";
import axios from 'axios';
import { show_alerta } from '../../funciones.js';
import CONFIG from '../../config';
import EmojiTextarea from './EmojiTextarea';
import Espera from '../Espera.js';
import EsperaFull from '../EsperaFull.js';

const URL_USUARIOS = `${CONFIG.API_URL}/operarTablaUsuario.php`;

function MensajesCrudForm({ enviarFormData, respuesta_a, para_r, asunto_r, llamoNuevo, cerrarModal, textareaRef, preload, esChat = false }) {
    const [de, setDe] = useState("");
    const [para, setPara] = useState(para_r);
    const [asunto, setAsunto] = useState(asunto_r);
    const [mensaje, setMensaje] = useState("");
    const [files, setFiles] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [sugerencias, setSugerencias] = useState([]);
    const [habilitaEnvio, setHabilitaEnvio] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const loggeduserRolId = localStorage.getItem('loggeduserRolId');
    const [mostrarModalAdjunto, setMostrarModalAdjunto] = useState(false);
    const [mostrarWebcamModal, setMostrarWebcamModal] = useState(false);
    const fileInputRef = useRef(null);
    const cameraPhotoRef = useRef(null);
    const cameraVideoRef = useRef(null);
    const videoWebcamRef = useRef(null);
    const streamWebcamRef = useRef(null);

    //Para grabacion
    const [grabando, setGrabando] = useState(false);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [audioBlob, setAudioBlob] = useState(null);
    const [audioURL, setAudioURL] = useState(null);
    const [tiempoGrabacion, setTiempoGrabacion] = useState(0);
    const timerRef = useRef(null);
    const streamRef = useRef(null);

    useEffect(() => {
        setDe(JSON.parse(localStorage.getItem('loggeddatosuser')).usuario);
        obtenerUsuariosPermitidos(loggeduserRolId);
    }, []);

    const [facingMode, setFacingMode] = useState('environment');

    const handleFilesSelected = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const selected = Array.from(e.target.files);
            setFiles((prev) => [...prev, ...selected]);
        }
        setMostrarModalAdjunto(false);
        e.target.value = '';
    };

    const abrirCamara = (tipo) => {
        setMostrarModalAdjunto(false);
        if (tipo === 'foto') {
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                iniciarWebcam(facingMode);
            } else {
                cameraPhotoRef.current?.click();
            }
        } else {
            cameraVideoRef.current?.click();
        }
    };

    const iniciarWebcam = async (modoActual = facingMode) => {
        if (streamWebcamRef.current) {
            streamWebcamRef.current.getTracks().forEach(track => track.stop());
            streamWebcamRef.current = null;
        }

        try {
            const constraints = {
                video: {
                    facingMode: { ideal: modoActual }
                }
            };
            const stream = await navigator.mediaDevices.getUserMedia(constraints);
            streamWebcamRef.current = stream;
            setMostrarWebcamModal(true);
            setTimeout(() => {
                if (videoWebcamRef.current) {
                    videoWebcamRef.current.srcObject = stream;
                    videoWebcamRef.current.play().catch(e => console.error("Error al reproducir video:", e));
                }
            }, 300);
        } catch (err) {
            console.error("No se pudo acceder a la cámara vía mediaDevices:", err);
            cameraPhotoRef.current?.click();
        }
    };

    const alternarCamara = () => {
        const nuevoModo = facingMode === 'environment' ? 'user' : 'environment';
        setFacingMode(nuevoModo);
        iniciarWebcam(nuevoModo);
    };

    const capturarFotoWebcam = () => {
        if (!videoWebcamRef.current) return;
        const video = videoWebcamRef.current;
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth || 640;
        canvas.height = video.videoHeight || 480;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        canvas.toBlob((blob) => {
            if (blob) {
                const file = new File([blob], `foto_camara_${Date.now()}.jpg`, { type: 'image/jpeg' });
                setFiles((prev) => [...prev, file]);
            }
            cerrarWebcam();
        }, 'image/jpeg', 0.9);
    };

    const cerrarWebcam = () => {
        if (streamWebcamRef.current) {
            streamWebcamRef.current.getTracks().forEach(track => track.stop());
            streamWebcamRef.current = null;
        }
        setMostrarWebcamModal(false);
    };
    
    const obtenerUsuariosPermitidos = (rol_origen) =>{
        axios.get(`${URL_USUARIOS}?rol_origen=${rol_origen}`)
            .then(res => { setUsuarios(res.data); console.log('usuariosPermitidos:',res.data);})
            .catch(err => { console.error("Error al obtener usuarios:", err); });
    }
    
    useEffect(() => {
        const termino = para.split(',').slice(-1)[0].trim();

        if (termino.length >= 2) {

            const texto = normalizarTexto(termino);

            const filteredUsers = usuarios.filter(usuario =>
                normalizarTexto(
                    `${usuario.nombre} ${usuario.apellido} ${usuario.usuario} ${usuario.roles || ''}`
                ).includes(texto)
            );

            setSugerencias(filteredUsers);
        } else {
            setSugerencias([]);
        }
    }, [para, usuarios]);

    const seleccionarUsuario = (usuario) => {
        const nuevosPara = para.split(',').slice(0, -1).concat(`${usuario.usuario} <<${usuario.nombre} ${usuario.apellido}>>,`).join(', ');
        setPara(nuevosPara);
        setHabilitaEnvio(true);
        setSugerencias([]);
    };

    const handleSubmint = async (e) => {
        e.preventDefault();
        
        if (isSubmitting || preload) return;
        setIsSubmitting(true);

        let finalAsunto = asunto;
        if (esChat && !finalAsunto) {
            finalAsunto = 'Chat';
        }

        if (!para) {
            show_alerta('Faltan datos', 'error');
            return;
        }

        const formData = new FormData();
        formData.append('respuesta_a', respuesta_a);
        formData.append('de', de);
        formData.append('para', para);
        formData.append('asunto', finalAsunto);
        formData.append('mensaje', mensaje);

        files.forEach((file, index) => {
            formData.append(`file${index}`, file);
        });
        if (audioBlob) {
            formData.append('audio', audioBlob, 'audio.webm');
        }
        
        try {
            await enviarFormData(formData);
        } finally {
            setIsSubmitting(false);
        }

        //si es vista chat limpiar solo el mensaje adjuntos y audios
        if (esChat) {
            setMensaje("");
            setFiles([]);
            setAudioBlob(null);
            setAudioURL(null);
            return;
        }else{
            handleReset();
        }
    }

    const handleReset = () => {
        setPara("");
        setAsunto("");
        setMensaje("");
        setFiles([]);
        setAudioBlob(null);
        setAudioURL(null);
    };

    const handleCerrar = () => {
        if (llamoNuevo) {
            cerrarModal();
        } else {
            cerrarModal(false);
        }
    };

    const normalizarTexto = (texto) => {
        return (texto || "")
            .toLowerCase()
            .normalize("NFD") // separa letras de acentos
            .replace(/[\u0300-\u036f]/g, ""); // elimina acentos
    };
    
    //Funciones para  grabacion de audio
    const iniciarGrabacion = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            streamRef.current = stream; // 👈 GUARDAR STREAM

            const recorder = new MediaRecorder(stream);

            let chunks = [];

            recorder.ondataavailable = (e) => {
                chunks.push(e.data);
            };

            recorder.onstop = () => {
                const blob = new Blob(chunks, { type: 'audio/webm' });
                setAudioBlob(blob);
                setAudioURL(URL.createObjectURL(blob));
            };

            recorder.start();
            setMediaRecorder(recorder);
            setGrabando(true);

            // 🔥 INICIAR CONTADOR
            setTiempoGrabacion(0);
            timerRef.current = setInterval(() => {
                setTiempoGrabacion(prev => prev + 1);
            }, 1000);

        } catch (err) {
            console.error(err);
            show_alerta("No se pudo acceder al micrófono", "error");
        }
    };

    const detenerGrabacion = () => {
        if (mediaRecorder) {
            mediaRecorder.stop();
            setGrabando(false);
            
            // 🔥 DETENER MICRÓFONO REAL
            if (streamRef.current) {
                streamRef.current.getTracks().forEach(track => track.stop());
                streamRef.current = null;
            }
            // DETENER CONTADOR
            clearInterval(timerRef.current);
        }
    };

    const formatearTiempo = (segundos) => {
        const min = Math.floor(segundos / 60);
        const sec = segundos % 60;
        return `${min}:${sec.toString().padStart(2, '0')}`;
    };

    return (
    <div className="me-2 mb-4">
    {!preload?  
        <form onSubmit={handleSubmint} id='form'>
            <input type="hidden" name="respuesta_a" value={respuesta_a} />
            {/*llamoNuevo: si es mensaje directo nuevo acomodo encabezado del form para y asunto */}
            {/*para_r=='': muestro campo de texto para ingresar destinatario y buscador de usuarios */}
            {llamoNuevo? 
            <>
                {para_r==''?
                <>
                    <div className='input-group input-group-sm mb-3'>
                        <span className='input-group-text' id='inputGroup-sizing-sm'>Para</span>
                        <input
                            type="text"
                            className="form-control bg-light"
                            name="para"
                            placeholder="Destinatario"
                            autoComplete="off"
                            value={para}
                            onChange={(e) => setPara(e.target.value)}
                            aria-label="Sizing example input" 
                            aria-describedby="inputGroup-sizing-sm"
                        />
                    </div>
                    {sugerencias.length > 0 && (
                        <ul className="lista-sugerencias">
                            {sugerencias.map(usuario => (
                                <li key={usuario.usuario} onClick={() => seleccionarUsuario(usuario)}>
                                    {usuario.nombre} {usuario.apellido} 
                                    <small style={{color: '#666'}}> ({usuario.roles})</small>
                                </li>
                            ))}
                        </ul>
                    )}
                    {para}
                </>    
                :
                    <input type="hidden" name="para" value={para} />
                }              
                
                {!esChat && (
                    <div className='input-group m-1'>
                        <span className='input-group-text small'>Asunto</span>
                        <input
                            type="text"
                            className="form-control bg-light"
                            name="asunto"
                            onChange={(e) => setAsunto(e.target.value)}
                            value={asunto}
                        />
                    </div>
                )}
            </>
            : 
            <>
                {/*Si es respuesta a mensaje o mensaje grupal, los campos para y asunto vienen ocultos*/}
                <input type="hidden" name="para" value={para} />
                <input type="hidden" name="asunto" value={asunto} />
            </>
            }

            {/* NUEVO TEXTAREA CON EMOJIS */}
            {/* si se activo envio de audio oculto el area de texto */}
            {/* SOLO mensajes nuevos */}
            {(llamoNuevo && para_r=='') && (
                <EmojiTextarea
                    value={mensaje}
                    onChange={setMensaje}
                    rows={5}
                    placeholder="Mensaje aquí"
                    name="mensaje"
                />
            )}
            {/* BOTONERA al PIE  */}
            <div className={`chat-toolbar ${respuesta_a === 0 && para_r === '' ? 'toolbar-directo' : 'toolbar-grupo'}`}>

                {/* IZQUIERDA */}
                <div className="toolbar-left">
                    {!(llamoNuevo && para_r=='') && (
                        <>
                            {!audioURL ?
                                !grabando ? (
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary btn-sm"
                                        onClick={iniciarGrabacion}
                                    >
                                        <i className="fa-solid fa-microphone"></i>
                                    </button>
                                ) : (
                                    <div className="d-flex align-items-center gap-2 w-100">
                                        <div className="grabando-indicador flex-grow-1">
                                            <div className="punto-rojo-parpadeando"></div>
                                            
                                            <span className="tiempo-grabacion">
                                                {formatearTiempo(tiempoGrabacion)}
                                            </span>

                                            <div className="ondas-audio ms-2">
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                            </div>
                                        </div>

                                        <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={detenerGrabacion}
                                        >
                                            <i className="fa-solid fa-stop"></i>
                                        </button>
                                    </div>
                                )
                            :
                            <>
                                <audio className='audio-url' controls src={audioURL}></audio>
                                <button 
                                    type='button' 
                                    className='btn btn-outline-secondary btn-sm' 
                                    onClick={()=>{
                                        setAudioURL(null);
                                        setAudioBlob(null);
                                    }}>
                                        <i className="fa-regular fa-trash-can"></i>
                                </button>
                            </>
                            }
                        </>
                    )}

                    {!audioURL && !grabando && (
                        <div className="position-relative d-inline-block me-1">
                            <button 
                                type="button" 
                                className="btn btn-outline-secondary btn-sm position-relative"
                                title="Adjuntar contenido"
                                onClick={() => setMostrarModalAdjunto(!mostrarModalAdjunto)}
                            >
                                <i className="fa-solid fa-paperclip"></i>
                                {files.length > 0 &&
                                    <span className="badge bg-primary ms-1">
                                        {files.length}
                                    </span>
                                }
                            </button>

                            {/* POPOVER COMPACTO ESTILO WHATSAPP */}
                            {mostrarModalAdjunto && (
                                <div 
                                    className="position-absolute bg-white shadow-lg border p-2 rounded-4 d-flex align-items-center gap-2"
                                    style={{
                                        bottom: '120%',
                                        left: '0',
                                        zIndex: 1050,
                                        minWidth: '160px'
                                    }}
                                >
                                    <button 
                                        type="button" 
                                        className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center p-0 shadow-sm"
                                        style={{ width: '38px', height: '38px' }}
                                        title="Archivos del equipo / Galería"
                                        onClick={() => {
                                            setMostrarModalAdjunto(false);
                                            fileInputRef.current?.click();
                                        }}
                                    >
                                        <i className="fa-solid fa-folder-open fs-6"></i>
                                    </button>

                                    <button 
                                        type="button" 
                                        className="btn btn-success rounded-circle d-flex align-items-center justify-content-center p-0 shadow-sm"
                                        style={{ width: '38px', height: '38px' }}
                                        title="Tomar Foto"
                                        onClick={() => abrirCamara('foto')}
                                    >
                                        <i className="fa-solid fa-camera fs-6"></i>
                                    </button>

                                    <button 
                                        type="button" 
                                        className="btn btn-danger rounded-circle d-flex align-items-center justify-content-center p-0 shadow-sm"
                                        style={{ width: '38px', height: '38px' }}
                                        title="Grabar Video"
                                        onClick={() => abrirCamara('video')}
                                    >
                                        <i className="fa-solid fa-video fs-6"></i>
                                    </button>

                                    <button 
                                        type="button" 
                                        className="btn btn-light rounded-circle text-secondary p-0 d-flex align-items-center justify-content-center ms-auto"
                                        style={{ width: '24px', height: '24px' }}
                                        onClick={() => setMostrarModalAdjunto(false)}
                                    >
                                        <i className="fa-solid fa-xmark small"></i>
                                    </button>
                                </div>
                            )}
                        </div>
                    )}

                    <input
                        type="file"
                        ref={fileInputRef}
                        multiple
                        hidden
                        onChange={handleFilesSelected}
                    />
                    <input
                        type="file"
                        ref={cameraPhotoRef}
                        accept="image/*"
                        capture="environment"
                        hidden
                        onChange={handleFilesSelected}
                    />
                    <input
                        type="file"
                        ref={cameraVideoRef}
                        accept="video/*"
                        capture="environment"
                        hidden
                        onChange={handleFilesSelected}
                    />
                    {/* TEXTAREA DENTRO DE LA BARRA */}
                    {!(llamoNuevo && para_r=='') && 
                    <>
                        {!audioURL && !grabando &&
                            <EmojiTextarea
                                value={mensaje}
                                onChange={setMensaje}
                                rows={1}
                                placeholder="Mensaje aquí"
                                name="mensaje"
                            />
                        }
                    </>}
                </div>

                {/* DERECHA */}
                <div className="toolbar-right ">
                    {(llamoNuevo && para_r=='') && (
                        <button
                            type="button"
                            className="btn btn-outline-warning btn-sm"
                            onClick={handleReset}
                        >
                            Limpiar
                        </button>
                    )}
                    
                    {!grabando && (
                        <button
                            className="btn btn-success btn-sm px-4"
                            type="submit"
                            disabled={(!habilitaEnvio && !respuesta_a && !para_r) || isSubmitting || preload}
                        >
                            <i className="fa-solid fa-paper-plane"></i>
                        </button>
                    )}
                    {llamoNuevo &&
                        <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={handleCerrar}
                        >
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                    }
                </div>
            </div>

            {/* CHIPS DE ARCHIVOS ADJUNTOS SELECCIONADOS */}
            {files.length > 0 && !audioURL && !grabando && (
                <div className="w-100 mt-2 p-2 bg-light rounded border d-flex flex-wrap gap-2 align-items-center">
                    <small className="fw-bold text-secondary me-1">Adjuntos ({files.length}):</small>
                    {files.map((f, idx) => (
                        <span key={idx} className="badge bg-secondary d-flex align-items-center gap-1 p-2 font-monospace">
                            <i className="fa-solid fa-paperclip small"></i>
                            <span className="text-truncate" style={{ maxWidth: '140px' }}>{f.name}</span>
                            <i 
                                className="fa-solid fa-xmark ms-1 text-white cursor-pointer" 
                                style={{ cursor: 'pointer' }}
                                title="Quitar este archivo"
                                onClick={() => setFiles(files.filter((_, i) => i !== idx))}
                            ></i>
                        </span>
                    ))}
                    <button 
                        type="button" 
                        className="btn btn-link btn-sm text-danger text-decoration-none ms-auto p-0 small"
                        onClick={() => setFiles([])}
                    >
                        Limpiar todo
                    </button>
                </div>
            )}

            {/* MODAL DE CAPTURA DE CÁMARA EN VIVO */}
            {mostrarWebcamModal && (
                <div className="modal-overlay" style={{ zIndex: 1070 }} onClick={cerrarWebcam}>
                    <div className="modal-contenido text-center p-3 shadow" style={{ maxWidth: '400px', borderRadius: '16px' }} onClick={(e) => e.stopPropagation()}>
                        <button type="button" className="btn-close float-end" onClick={cerrarWebcam}></button>
                        <h6 className="fw-bold mb-2 text-dark"><i className="fa-solid fa-camera me-2 text-success"></i>Cámara</h6>
                        <div className="bg-black rounded overflow-hidden mb-3 position-relative" style={{ height: '240px' }}>
                            <video ref={videoWebcamRef} style={{ width: '100%', height: '100%', objectFit: 'cover' }} autoPlay playsInline muted></video>
                            <button 
                                type="button" 
                                className="btn btn-sm btn-dark position-absolute bottom-0 end-0 m-2 opacity-75 rounded-circle"
                                style={{ width: '36px', height: '36px', padding: 0 }}
                                title="Cambiar cámara frontal/trasera"
                                onClick={alternarCamara}
                            >
                                <i className="fa-solid fa-rotate"></i>
                            </button>
                        </div>
                        <div className="d-flex justify-content-center gap-2">
                            <button type="button" className="btn btn-success px-4" onClick={capturarFotoWebcam}>
                                <i className="fa-solid fa-camera me-1"></i> Tomar Foto
                            </button>
                            <button type="button" className="btn btn-secondary px-3" onClick={cerrarWebcam}>
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </form>
    :
        <EsperaFull visible={preload} />
    }
    </div>
    )
}

export default MensajesCrudForm;
